// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import RoleSettings from './RoleSettings';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import "../../css/Settings.scss"
import { Button } from '@mui/material';
import { isAccessGranted } from '../../utils/oauth';
import { PRIVILEGES } from '../../Config';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Settings = () => {

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className='Settings'>
            <Box className='Settings-box'>

                <AppBar position="static">
                    <Tabs value={value} onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit">
                        {isAccessGranted([PRIVILEGES.ROLE_SETTINGS]) &&
                            <Tab label={
                                <Button color="secondary" onClick={() => { }} size='small' className='Tab-label' startIcon={<GroupAddIcon color='secondary' />}>
                                    {"Role Settings"}
                                </Button>
                            } {...a11yProps(0)} className='Tab-label' />}
                        {/* <Tab label={
                            <Button color="secondary" onClick={() => { }} size='small' className='Tab-label' >
                                {"My Visa Details"}
                            </Button>
                        } {...a11yProps(1)} /> */}
                    </Tabs>
                </AppBar>
            </Box>

            {isAccessGranted([PRIVILEGES.ROLE_SETTINGS]) &&
                <TabPanel value={value} index={0} children={(<RoleSettings />)}></TabPanel>}

        </div>
    );
}

export default Settings;